import { DateTime } from 'luxon';
import { getUserLanguage } from '@teachino/shared-i18n';

export function useDateFormat() {
  const formatDayLong = (
    date: Date | string,
    includeYear: boolean = false,
  ): string => {
    const luxonDate =
      typeof date === 'string'
        ? DateTime.fromISO(date)
        : DateTime.fromJSDate(date);

    return luxonDate.toLocaleString({
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: includeYear ? 'numeric' : undefined,
    });
  };

  const formatDayLongWithYear = (date: Date | string): string =>
    formatDayLong(date, true);

  function formatMonthYear(date: Date | string): string {
    const luxonDate =
      typeof date === 'string'
        ? DateTime.fromISO(date)
        : DateTime.fromJSDate(date);

    return luxonDate.setLocale(getUserLanguage()).toLocaleString({
      month: 'long',
      year: 'numeric',
    });
  }

  function formatDayShort(date: DateTime): string {
    //not using toLocalString to save some more characters
    return date.toFormat('ccc dd.LL');
  }

  function dateToDateString(date: DateTime): string {
    return date.toFormat('yyyy-MM-dd');
  }

  function formatDateRelative(date: string): string | null;
  function formatDateRelative(date: DateTime): string | null;
  function formatDateRelative(date: DateTime | string): string | null {
    const input = typeof date === 'string' ? DateTime.fromISO(date) : date;
    return input.toRelative();
  }

  function formatDateTimeRelative(dateInput: Date) {
    const date = DateTime.fromJSDate(dateInput).setLocale(getUserLanguage());
    const now = DateTime.now().setLocale(getUserLanguage());

    const hoursDifference = Math.abs(now.diff(date, 'hours').hours);

    const HOURS_IN_DAY = 24;
    if (hoursDifference < HOURS_IN_DAY) {
      return date.toRelative({ base: now });
    }

    return (
      date.toRelativeCalendar({ base: now }) ?? date.toRelative({ base: now })
    );
  }

  return {
    formatDayLong,
    formatDayLongWithYear,
    formatMonthYear,
    formatDayShort,
    dateToDateString,
    formatDateRelative,
    formatDateTimeRelative,
  };
}
